import { useChains } from "@opensea/app-kit"
import { Avatar } from "@opensea/next-ui-kit"
import { Block, classNames, Tooltip } from "@opensea/ui-kit"
import { useTranslations } from "next-intl"

type ChainBadgeIdentifierProps = {
  identifier: string
  className?: string
}

export function ChainBadge({
  identifier,
  className,
}: ChainBadgeIdentifierProps) {
  const { getLogo, getChainName } = useChains()
  const logo = getLogo(identifier)
  const name = getChainName(identifier)
  const t = useTranslations("ItemCardChainBadge")

  return (
    <Block className={classNames("absolute top-2 left-2", className)}>
      <Tooltip content={t("chain", { name })}>
        <div className="flex size-8 items-center justify-center rounded-full border border-black/4 bg-black/50 p-1.5">
          <Avatar size={20} {...logo} className="text-white" />
        </div>
      </Tooltip>
    </Block>
  )
}
